import axios, { type AxiosRequestConfig } from 'axios';
import { getEnvironment } from 'config/environments/environment';

const instance = axios.create({
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  }
});

instance.defaults.baseURL = getEnvironment().baseUrl;
instance.interceptors.request.use((cfg) => {
  const url = cfg.url ?? '';

  if (/^https?:\/\//i.test(url) || url.startsWith('//')) return cfg;

  if (
    url.startsWith('/sanctum') ||
    url.startsWith('sanctum') ||
    url.startsWith('/login') ||
    url.startsWith('login') ||
    url.startsWith('/logout') ||
    url.startsWith('logout') ||
    url.startsWith('/user') ||
    url.startsWith('user')
  ) {
    return cfg;
  }

  let u = url.startsWith('/') ? url : `/${url}`;
  if (!u.startsWith('/api/')) u = `/api${u}`;

  return { ...cfg, url: u };
});

export default instance;
